export class InsuranceProviders {
    static Renaissance = "d7c7f421-8402-44e4-8aa1-cf5175f71993";
    static Reso = "be2a7c0b-2298-413e-a82f-dab1644f02a8";
    static Alfa = "a4732d6f-de02-48b5-8354-0858c1a56f9d";
    static Ingostrah = "a4732d6f-de02-48b5-8354-0858c1a56f94";
    static Rgs = "91018413-be03-4e2e-abbb-f5ded3316f50";
    static Tinkoff = "91018413-be03-4e2e-abbb-f5ded3316f22";
    static Sngi = "91018413-be03-4e2e-abbb-f5ded3316f11";
    static Soglasie = "88fb54ed-7213-4a72-8d19-d3bddaa81c7b";
    static Zetta = "35cad103-64d2-43ff-8770-66afe42c8426";
    static Makc = "273110d7-5756-4cb0-8bb0-235f254f946a";
    static Ugoria = "88fb54ed-7213-4a72-8d19-d3bddaa81c44";
    static Vsk = "e5d86580-9760-436b-ada9-2963e2bef274";
    static Mafin = "dc183b6b-81f4-4a0c-88ab-a72c6958e7dc";
    static IngostrahCatC = "166cba1a-597b-4588-b27f-7bb9697037e9";
    static Sogaz = "de5fecfe-f2e4-4415-829d-052fdf6b9415";
    static RenaissanceCatC = "d7ef4e89-a201-4d69-bc40-a32f3e6f6fd6";
    static Astrovolga = "881ea455-2c2f-4727-9e4f-6a83ced81d6f";
    static Verna = "f5f37f39-e584-432d-9b07-8ef5acb64737";
    static Absolut = "79a78845-20a1-4481-a5c1-c5675fd51f36";
    static Euroins = "aa0105aa-076f-4d64-a6bc-ff6229023303";

    public static GetName(icId): string {
        return InsuranceProviders.Map.has(icId) ? InsuranceProviders.Map.get(icId) : "";
    }

    private static Map = new Map([
        [InsuranceProviders.Renaissance, "renaissance"],
        [InsuranceProviders.Reso, "reso"],
        [InsuranceProviders.Alfa, "alfa"],
        [InsuranceProviders.Ingostrah, "ingostrah"],
        [InsuranceProviders.Rgs, "rgs"],
        [InsuranceProviders.Tinkoff, "tinkoff"],
        [InsuranceProviders.Sngi, "sngi"],
        [InsuranceProviders.Soglasie, "soglasie"],
        [InsuranceProviders.Zetta, "zetta"],
        [InsuranceProviders.Makc, "makc"],
        [InsuranceProviders.Ugoria, "ugoria"],
        [InsuranceProviders.Vsk, "vsk"],
        [InsuranceProviders.Mafin, "mafin"],
        [InsuranceProviders.IngostrahCatC, "ingostrahC"],
        [InsuranceProviders.Sogaz, "sogaz"],
        [InsuranceProviders.RenaissanceCatC, "renaissanceC"],
        [InsuranceProviders.Astrovolga, "astrovolga"],
        [InsuranceProviders.Verna, "verna"],
        [InsuranceProviders.Absolut, "absolut"],
        [InsuranceProviders.Euroins, "euroins"],
    ]);
}
